import { Button, Group, Text } from '@mantine/core';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardClause } from '../../data-access/types/stats';

const CLAUSE_OPTIONS: DashboardClause[] = ['gp', 'new'];

export interface DashboardClauseCardsProps {
  value: DashboardClause;
  onChange: (value: DashboardClause) => void;
}

export const DashboardClauseCards: FC<DashboardClauseCardsProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <Group
      aria-label={t('sampling.results.clause.group_label')}
      gap="xs"
      role="radiogroup"
      wrap="wrap"
    >
      {CLAUSE_OPTIONS.map((clause) => {
        const active = value === clause;

        return (
          <Button
            key={clause}
            aria-checked={active}
            onClick={() => onChange(clause)}
            role="radio"
            type="button"
            variant={active ? 'filled' : 'default'}
          >
            {t(`clauses.${clause}`)}
            <Text c={active ? undefined : 'dimmed'} component="span" fw={500} ml="xs" size="xs">
              {t(`sampling.results.clause.${clause}_case`)}
            </Text>
          </Button>
        );
      })}
    </Group>
  );
};

export default DashboardClauseCards;
